module.exports = __webpack_public_path__ + "static/media/GooglePlay.ad8917fb.svg";